<style>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600;700;800&display=swap');

.nlp{
  --nlp-navy:#07468D;
  --nlp-pink:#F05798;
  --nlp-purple:#07468D;
  --nlp-green:#07468D;
  --nlp-ink:#243047;
  --nlp-ink-soft:#566176;
  --nlp-grey-bg:#eef4fb;
  --nlp-grey-row:#f7f7f7;
  --nlp-hero-bg:#f8f8f8;
  --nlp-green-pale:#eef4fb;
  --nlp-green-cell:#e6eff9;
  --nlp-cream-cell:#f7f9fc;
  --nlp-blue-pale:#eef4fb;
  --nlp-phone-blue:#cfe3f7;
  --nlp-sans:'Nunito',-apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif;
  --nlp-serif:Georgia,'Times New Roman',serif;
  --nlp-wrap:1200px;

  font-family:var(--nlp-sans);
  font-size:16px;
  font-weight:400;
  line-height:1.55;
  letter-spacing:normal;
  color:var(--nlp-ink);
  text-align:left;
  background:#fff;
  -webkit-font-smoothing:antialiased;
}
.nlp,.nlp *,.nlp *::before,.nlp *::after{box-sizing:border-box}
.nlp :where(h1,h2,h3,h4,h5,h6,p,ul,ol,li,blockquote,cite,span,small,b,i,figure){
  margin:0;
  padding:0;
  font:inherit;
  color:inherit;
  letter-spacing:inherit;
  text-transform:none;
  text-align:inherit;
}
.nlp :where(ul,ol){list-style:none}
.nlp :where(img){display:block;width:auto;max-width:100%;height:auto;border:0;vertical-align:baseline}
.nlp :where(svg){display:block;overflow:visible}
.nlp :where(a){color:inherit;text-decoration:none;background:none}
.nlp-sprite{position:absolute;width:0;height:0;overflow:hidden}
.nlp-wrap{max-width:var(--nlp-wrap);margin:0 auto;padding:0 32px}

.nlp-btn{
  display:inline-flex;
  align-items:center;
  justify-content:space-between;
  gap:28px;
  min-width:min(100%,290px);
  min-height:62px;
  padding:14px 22px;
  border:0;
  border-radius:9px;
  font-family:inherit;
  text-align:left;
  text-decoration:none;
  cursor:pointer;
  transition:filter .18s ease,transform .18s ease;
}
.nlp-btn:disabled{cursor:wait;filter:saturate(.7);opacity:.8}
.nlp-btn:hover{filter:brightness(1.06);text-decoration:none}
.nlp-btn:active{transform:translateY(1px)}
.nlp-btn:focus-visible{outline:3px solid #111;outline-offset:3px}
.nlp-btn--pink{background:var(--nlp-pink);color:#fff}
.nlp-btn--navy{background:var(--nlp-navy);color:#fff}
.nlp-btn__label{display:block;font-size:18px;font-weight:800;line-height:1.2}
.nlp-btn__price{display:block;margin-top:3px;font-size:20px;font-weight:400;line-height:1.2}
.nlp-btn__price small{margin-left:2px;font-size:13px}
.nlp-btn__arrow{flex:none;font-size:22px;line-height:1}
.nlp-btn-row{display:flex;justify-content:center;margin-top:56px}
.nlp-btn-row .nlp-btn{min-width:min(100%,290px)}

.nlp-powered{display:inline-flex;align-items:center;gap:7px;text-decoration:none}
.nlp-powered span{font-size:14px;line-height:1}
.nlp-powered img{width:auto;height:19px}
.nlp-powered:hover img{opacity:.85}
.nlp-powered:focus-visible{outline:2px solid var(--nlp-navy);outline-offset:4px;border-radius:3px}

.nlp-hero{background:var(--nlp-hero-bg)}
.nlp-hero__grid{display:grid;grid-template-columns:1fr 1fr;min-height:650px}
.nlp-hero__copy{padding:72px 60px 72px max(32px,calc((100vw - 1300px)/2 + 32px))}
.nlp-hero h1{
  margin:0 0 26px;
  font-size:clamp(34px,3.4vw,46px);
  font-weight:800;
  line-height:1.1;
  letter-spacing:-.01em;
  color:var(--nlp-navy);
}
.nlp-hero h1 span{display:block}
.nlp-hero__accent{color:var(--nlp-pink)}
.nlp-hero__lede{margin:0 0 24px;max-width:590px;color:var(--nlp-ink-soft);font-size:18px;line-height:1.6}
.nlp-hero__list{margin:0 0 32px;padding-left:20px;max-width:500px;list-style:disc}
.nlp-hero__list li{display:list-item;margin-bottom:5px}
.nlp-hero__cta{margin-bottom:26px}
.nlp-hero__cta .nlp-btn{padding:14px 22px}
.nlp-hero__coachline{margin:0 0 14px;font-size:15px}
.nlp-hero__avatars{display:flex;margin-bottom:30px}
.nlp-hero__avatars img{
  width:62px;
  height:62px;
  margin-right:-14px;
  border:3px solid var(--nlp-hero-bg);
  border-radius:50%;
  background:#dfe8f2;
  object-fit:cover;
  object-position:50% 18%;
}
.nlp-hero__media{position:relative;min-height:420px}
.nlp-hero__media img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:32% 55%}

.nlp-section{padding:84px 0}
.nlp-section--grey{background:var(--nlp-grey-bg)}
.nlp-section__head{max-width:790px;margin:0 auto 52px;text-align:center}
.nlp-section__head h2{
  margin:0;
  font-size:clamp(30px,3vw,42px);
  font-weight:800;
  line-height:1.15;
  letter-spacing:-.018em;
}
.nlp-section__head h2.nlp-is-purple{color:var(--nlp-purple)}
.nlp-section__head h2.nlp-is-navy{color:var(--nlp-navy)}
.nlp-section__head p{margin:16px auto 0;max-width:760px;color:var(--nlp-ink-soft);font-size:17px;line-height:1.6}
.nlp-section__head p.nlp-is-navy{color:var(--nlp-navy);font-size:21px;font-weight:700}

.nlp-benefits{display:grid;grid-template-columns:repeat(3,1fr);gap:38px 44px}
.nlp-benefit img{width:100%;aspect-ratio:5/3;border-radius:12px;object-fit:cover}
.nlp-benefit h3{margin:20px 0 8px;font-size:20px;font-weight:800;line-height:1.3}
.nlp-benefit p{margin:0;color:var(--nlp-ink-soft);font-size:15px;line-height:1.55}

.nlp-plan{position:relative;display:grid;grid-template-columns:repeat(4,1fr);gap:28px}
.nlp-plan::before{content:"";position:absolute;top:52px;right:-32px;left:-32px;height:1px;background:#d5d5d5}
.nlp-stage{display:flex;flex-direction:column}
.nlp-stage__week{margin-bottom:16px;font-size:16px;font-weight:700;letter-spacing:.06em;text-align:center}
.nlp-stage__marker{
  position:relative;
  z-index:2;
  width:26px;
  height:26px;
  margin:0 auto 26px;
  border:4px solid #fff;
  border-radius:50%;
  background:var(--nlp-green);
  box-shadow:0 0 0 1px #dcdcdc;
}
.nlp-stage__card{
  position:relative;
  flex:1;
  padding:18px 15px 15px;
  border-radius:12px;
  background:#fff;
  box-shadow:0 1px 3px rgba(0,0,0,.07);
}
.nlp-stage__card::before{
  content:"";
  position:absolute;
  top:-11px;
  left:50%;
  transform:translateX(-50%);
  border-right:12px solid transparent;
  border-bottom:11px solid #fff;
  border-left:12px solid transparent;
}
.nlp-stage__head{display:flex;align-items:center;gap:13px;margin-bottom:18px}
.nlp-stage__badge{
  display:flex;
  align-items:center;
  justify-content:center;
  flex:none;
  width:52px;
  height:52px;
  border-radius:50%;
  background:var(--nlp-green-pale);
}
.nlp-stage__badge img{width:30px;height:30px;object-fit:contain}
.nlp-stage__title{display:block;font-size:19px;font-weight:600;line-height:1.2}
.nlp-stage__split{display:grid;grid-template-columns:1fr 1fr;border-radius:6px;overflow:hidden}
.nlp-stage__col{display:flex;flex-direction:column}
.nlp-stage__col--you{background:var(--nlp-cream-cell)}
.nlp-stage__col--coach{background:var(--nlp-green-cell)}
.nlp-stage__col h4{margin:0;padding:6px 4px;font-size:14px;font-weight:400;text-align:center}
.nlp-stage__col img{width:100%;aspect-ratio:145/154;object-fit:cover}
.nlp-stage__col p{margin:0;padding:11px 10px 14px;font-size:14px;line-height:1.3}

.nlp-included{display:grid;grid-template-columns:1fr 1fr;gap:29px}
.nlp-included__preview{background:var(--nlp-phone-blue)}
.nlp-included__preview img{width:100%;aspect-ratio:657/911;object-fit:cover}
.nlp-included__list{display:grid;grid-template-rows:repeat(6,1fr);gap:15px}
.nlp-included__item{
  display:flex;
  align-items:center;
  gap:26px;
  padding:0 24px 0 29px;
  background:var(--nlp-grey-row);
}
.nlp-included__icon{display:flex;align-items:center;flex:none;width:49px}
.nlp-included__item span:last-child{font-size:23px;line-height:1.37}

.nlp-coaches{display:grid;grid-template-columns:repeat(5,1fr);gap:30px}
.nlp-coach img{width:100%;aspect-ratio:4/5;border-radius:10px;background:#cfe0ef;object-fit:cover}
.nlp-coach h3{margin:16px 0 3px;font-size:18px;font-weight:700}
.nlp-coach p{margin:0;font-size:15px;color:var(--nlp-ink-soft)}
.nlp-creds{
  display:flex;
  flex-wrap:wrap;
  justify-content:center;
  gap:70px;
  margin-top:56px;
  padding:34px 30px;
  border-radius:14px;
  background:var(--nlp-grey-row);
}
.nlp-creds__item{display:flex;align-items:center;gap:16px}
.nlp-creds__item p{margin:0}
.nlp-creds__item img{flex:none;width:36px;height:36px;object-fit:contain}
.nlp-creds__item b{display:block;font-family:var(--nlp-serif);font-size:27px;font-weight:400;line-height:1.15}
.nlp-creds__item span{font-family:var(--nlp-serif);font-size:17px}

.nlp-reviews{display:grid;grid-template-columns:1fr 1fr;gap:34px}
.nlp-review{display:flex;flex-direction:column;padding:32px 34px 26px;border-radius:12px;background:var(--nlp-green-pale)}
.nlp-review__stars{display:flex;gap:9px;margin-bottom:18px}
.nlp-review__stars svg{width:19px;height:19px;fill:var(--nlp-green)}
.nlp-review blockquote{margin:0 0 24px;font-size:18px;line-height:1.55;quotes:none}
.nlp-review blockquote::before,.nlp-review blockquote::after{content:none}
.nlp-review cite{margin-top:auto;font-size:14px;font-weight:700;font-style:normal;color:#5f7627}
.nlp-figures{display:grid;grid-template-columns:repeat(3,1fr);gap:34px;margin-top:34px}
.nlp-figures__item{padding:28px 30px 30px;border-radius:12px;background:var(--nlp-green-pale)}
.nlp-figures__item b{display:block;margin-bottom:6px;font-size:44px;font-weight:400;line-height:1.1}
.nlp-figures__item span{font-size:16px}

.nlp-closing{padding:0 12px 20px}
.nlp-closing__card{
  display:grid;
  grid-template-columns:0.94fr 1fr;
  gap:41px;
  align-items:center;
  max-width:1400px;
  margin:0 auto;
  padding:56px 40px;
  border-radius:12px;
  background:var(--nlp-blue-pale);
}
.nlp-closing h2{
  margin:0 0 12px;
  font-size:clamp(30px,3.4vw,47px);
  font-weight:700;
  line-height:1.2;
  letter-spacing:-.01em;
  color:var(--nlp-purple);
}
.nlp-closing__lede{margin:0 0 58px;max-width:430px;font-size:18px;line-height:1.55}
.nlp-closing__price{margin:0;font-size:48px;font-weight:700;line-height:1;color:var(--nlp-purple)}
.nlp-closing__terms{margin:12px 0 30px;font-size:16px;letter-spacing:.07em}
.nlp-closing ul{margin:0 0 36px;padding:0;list-style:none}
.nlp-closing li{display:flex;align-items:center;gap:19px;font-size:19px}
.nlp-closing li + li{margin-top:19px}
.nlp-closing li svg{flex:none;width:32px;height:32px}
.nlp-closing .nlp-btn{width:min(100%,340px);justify-content:center;gap:10px;padding:14px 22px}
.nlp-closing .nlp-btn .nlp-btn__label{font-size:18px}
.nlp-closing__foot{display:flex;flex-wrap:wrap;align-items:center;gap:104px;margin-top:22px}
.nlp-closing__secure{display:flex;align-items:center;gap:14px;font-size:17px}
.nlp-closing__secure svg{flex:none;width:21px;height:25px}
.nlp-closing__media img{width:100%;aspect-ratio:1.08;border-radius:12px;object-fit:cover}

@media (max-width:1080px){
  .nlp-benefits{gap:34px 30px}
  .nlp-plan{grid-template-columns:repeat(2,1fr);row-gap:44px}
  .nlp-plan::before{display:none}
  .nlp-coaches{grid-template-columns:repeat(3,1fr)}
  .nlp-included{grid-template-columns:1fr;gap:26px}
  .nlp-included__preview{max-width:520px;margin:0 auto}
  .nlp-included__list{grid-template-rows:none;gap:14px}
  .nlp-included__item{min-height:104px}
}
@media (max-width:900px){
  .nlp-hero__grid{grid-template-columns:1fr}
  .nlp-hero__copy{order:2;padding:56px 28px 48px}
  .nlp-hero__media{order:1;height:44vw;min-height:340px;max-height:460px}
  .nlp-closing__card{grid-template-columns:1fr;gap:34px;padding:44px 28px}
  .nlp-closing__media{order:-1}
  .nlp-closing__lede{margin-bottom:40px}
  .nlp-closing__foot{gap:36px}
}
@media (max-width:720px){
  .nlp-wrap{padding:0 22px}
  .nlp-section{padding:64px 0}
  .nlp-section__head{margin-bottom:38px}
  .nlp-btn{gap:16px}
  .nlp-benefits{grid-template-columns:1fr;gap:30px}
  .nlp-plan{grid-template-columns:1fr}
  .nlp-coaches{grid-template-columns:repeat(2,1fr);gap:24px}
  .nlp-included__item span:last-child{font-size:19px}
  .nlp-included__item{gap:20px;padding:0 20px}
  .nlp-reviews{grid-template-columns:1fr}
  .nlp-figures{grid-template-columns:1fr;gap:18px}
  .nlp-creds{flex-direction:column;align-items:flex-start;gap:26px;padding:28px 26px}
  .nlp-btn-row .nlp-btn{min-width:0;width:100%}
  .nlp-hero__cta .nlp-btn{width:100%}
}
@media (max-width:480px){
  .nlp-hero__copy{padding:46px 22px 52px}
  .nlp-hero h1{margin-bottom:20px;font-size:32px}
  .nlp-hero__list{padding-left:18px}
  .nlp-hero__avatars img{width:54px;height:54px;margin-right:-12px}
  .nlp-section__head h2{font-size:30px}
  .nlp-section__head p{font-size:16px}
  .nlp-section__head p.nlp-is-navy{font-size:19px}
  .nlp-btn{padding:14px 22px}
  .nlp-btn__label{font-size:18px}
  .nlp-btn__price{font-size:20px}
  .nlp-included__item span:last-child{font-size:18px}
  .nlp-review{padding:26px 24px 22px}
  .nlp-review blockquote{font-size:17px}
  .nlp-closing{padding:0 8px 20px}
  .nlp-closing__card{padding:36px 22px}
  .nlp-closing__lede{margin-bottom:32px;font-size:17px}
  .nlp-closing__price{font-size:40px}
  .nlp-closing__terms{font-size:15px}
  .nlp-closing li{gap:14px;font-size:17px}
  .nlp-closing li + li{margin-top:15px}
  .nlp-closing li svg{width:28px;height:28px}
  .nlp-closing .nlp-btn{padding:14px 22px}
  .nlp-closing .nlp-btn .nlp-btn__label{font-size:18px}
}
@media (prefers-reduced-motion:reduce){
  .nlp *{transition:none !important}
}

.nutrable-program-page{min-height:100vh;background:#fff;font-family:var(--nlp-sans)}
.nutrable-program__portal-header{max-width:1200px;margin:0 auto;padding:0}
.nutrable-program__portal-header .uk-navbar-container{background:#fff !important}
.nutrable-program__notice{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:24px;
  max-width:1200px;
  margin:18px auto;
  padding:18px 22px;
  border-radius:12px;
  background:#edf6d9;
  color:#294f20;
}
.nutrable-program__notice strong{display:block;margin-bottom:3px;font-size:17px}
.nutrable-program__notice p{margin:0;color:inherit}
.nutrable-program__notice-link{
  flex:none;
  padding:12px 18px;
  border:0;
  border-radius:8px;
  background:#07468D;
  color:#fff;
  font:700 15px/1.2 var(--nlp-sans);
  cursor:pointer;
}
.nutrable-program__error{
  max-width:1200px;
  margin:18px auto;
  padding:14px 18px;
  border-radius:10px;
  background:#fff0ee;
  color:#8d2c1f;
}
.nutrable-program__modal-backdrop{
  position:fixed;
  z-index:1100;
  inset:0;
  display:grid;
  place-items:center;
  padding:20px;
  background:rgba(10,24,44,.58);
}
.nutrable-program__modal{
  width:min(100%,520px);
  padding:28px;
  border-radius:14px;
  background:#fff;
  box-shadow:0 24px 70px rgba(0,0,0,.28);
  color:#222;
}
.nutrable-program__modal h2{margin:0 0 12px;color:#07468D;font:800 24px/1.2 var(--nlp-sans)}
.nutrable-program__modal p{margin:0 0 12px;font:400 16px/1.5 var(--nlp-sans)}
.nutrable-program__modal-email{overflow-wrap:anywhere;font-weight:700}
.nutrable-program__modal-actions{display:flex;justify-content:flex-end;gap:12px;margin-top:24px}
.nutrable-program__modal-actions button{padding:12px 18px;border-radius:8px;font:700 15px/1.2 var(--nlp-sans);cursor:pointer}
.nutrable-program__modal-cancel{border:1px solid #9aa6b2;background:#fff;color:#25384a}
.nutrable-program__modal-confirm{border:0;background:#07468D;color:#fff}
.nutrable-program__modal-actions button:disabled{cursor:wait;opacity:.7}
.nlp .nlp-btn{color:#fff !important}
.nlp .nlp-powered{color:inherit !important}
@media (max-width:720px){
  .nutrable-program__portal-header{padding:0}
  .nutrable-program__notice{align-items:flex-start;margin:12px 14px;padding:16px;flex-direction:column}
  .nutrable-program__notice-link{width:100%}
  .nutrable-program__error{margin:12px 14px}
  .nutrable-program__modal{padding:22px}
  .nutrable-program__modal-actions{align-items:stretch;flex-direction:column-reverse}
}
</style>

<template>
<div class="nutrable-program-page">
<div class="nutrable-program__portal-header"><UserHeader /></div>

<div v-if="showProgramNotice" class="nutrable-program__notice" role="status">
  <div>
    <strong>{{ programNoticeTitle }}</strong>
    <p>{{ programNoticeBody }}</p>
  </div>
  <button
    v-if="needsRegistration || isProgramActive"
    type="button"
    class="nutrable-program__notice-link"
    @click="noticeAction"
  >
    {{ needsRegistration ? 'Activate Nutrable Access' : 'Access Nutrable Account' }}
  </button>
</div>

<div
  v-if="error"
  ref="checkoutError"
  class="nutrable-program__error"
  role="alert"
  tabindex="-1"
>
  {{ error }}
</div>

<div
  v-if="showRegistrationConfirm"
  class="nutrable-program__modal-backdrop"
  @click.self="closeRegistrationConfirm"
  @keydown.esc="closeRegistrationConfirm"
>
  <section
    ref="registrationDialog"
    class="nutrable-program__modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="nutrable-confirm-title"
    tabindex="-1"
  >
    <h2 id="nutrable-confirm-title">Activate your Nutrable program?</h2>
    <p>We’ll create or renew your Nutrable membership using:</p>
    <p class="nutrable-program__modal-email">{{ enrollment?.registration_email }}</p>
    <p>Nutrable will email you from no-reply@nutrable.com if account setup is required. Your 12-week access begins when you confirm.</p>
    <div class="nutrable-program__modal-actions">
      <button
        type="button"
        class="nutrable-program__modal-cancel"
        :disabled="registrationLoading"
        @click="closeRegistrationConfirm"
      >
        Not now
      </button>
      <button
        type="button"
        class="nutrable-program__modal-confirm"
        :disabled="registrationLoading"
        :aria-busy="registrationLoading"
        @click="confirmRegistration"
      >
        {{ registrationLoading ? 'Activating…' : 'Confirm and activate' }}
      </button>
    </div>
  </section>
</div>

<main class="nlp">

<svg class="nlp-sprite" aria-hidden="true" focusable="false">
  <symbol id="nlp-star" viewBox="0 0 24 24"><path d="m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.9L12 17.8 5.8 21l1.2-6.9-5-4.9 6.9-1L12 2Z"/></symbol>
  <symbol id="nlp-tick" viewBox="0 0 26 26"><circle cx="13" cy="13" r="13" fill="#07468D"/><path d="m7.4 13.4 3.7 3.7 7.5-7.9" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></symbol>
</svg>

<section class="nlp-hero">
  <div class="nlp-hero__grid">
    <div class="nlp-hero__copy">
      <h1><span>12-Week</span><span class="nlp-hero__accent">Food Intolerance</span><span>Nutrition Coaching</span></h1>
      <p class="nlp-hero__lede">Your own nutrition coach, supporting you every step of the way towards kinder food choices and better wellbeing.</p>
      <ul class="nlp-hero__list">
        <li>Understand your results and what they mean for you</li>
        <li>Identify and reduce potential trigger foods</li>
        <li>Navigate elimination and reintroduction with support</li>
        <li>Build lasting habits to help you feel your best</li>
        <li>Maintain a balanced, nutritious diet with confidence</li>
      </ul>
      <div class="nlp-hero__cta">
        <button
          type="button"
          class="nlp-btn nlp-btn--pink"
          :disabled="actionDisabled"
          :aria-busy="actionLoading"
          @click="handleCtaClick"
        >
          <span>
            <span class="nlp-btn__label">{{ ctaLabel }}</span>
            <span v-if="!isProgramActive && !needsRegistration" class="nlp-btn__price">{{ programPrice }} <small>one-time payment</small></span>
          </span>
          <span class="nlp-btn__arrow" aria-hidden="true">&rarr;</span>
        </button>
      </div>
      <p class="nlp-hero__coachline">Includes your dedicated nutrition coach</p>
      <div class="nlp-hero__avatars">
        <img src="/images/nutrable-program/avatar-1.jpg" width="62" height="62" alt="Coach Louise">
        <img src="/images/nutrable-program/avatar-2.jpg" width="62" height="62" alt="Coach Julia">
        <img src="/images/nutrable-program/avatar-3.jpg" width="62" height="62" alt="Coach Mike">
        <img src="/images/nutrable-program/avatar-4.jpg" width="62" height="62" alt="Coach Brigitta">
        <img src="/images/nutrable-program/avatar-5.jpg" width="62" height="62" alt="Coach Lisa">
      </div>
      <a class="nlp-powered" href="https://www.nutrable.com" target="_blank" rel="noopener">
        <span>powered by</span>
        <img src="/images/nutrable-program/logo-nutrable.png" width="107" height="19" alt="Nutrable">
      </a>
    </div>
    <div class="nlp-hero__media">
      <img src="/images/nutrable-program/hero-home.jpg" alt="Woman using the Nutrable app in her kitchen surrounded by fresh vegetables">
    </div>
  </div>
</section>

<section class="nlp-section">
  <div class="nlp-wrap">
    <div class="nlp-section__head">
      <h2 class="nlp-is-purple">Understand Your Food Triggers<br>and Start Feeling Better</h2>
    </div>
    <div class="nlp-benefits">
      <article class="nlp-benefit">
        <img src="/images/nutrable-program/benefit-1.jpg" alt="Person holding their stomach">
        <h3>Ease bloating &amp; discomfort</h3>
        <p>Identify foods causing digestive discomfort.</p>
      </article>
      <article class="nlp-benefit">
        <img src="/images/nutrable-program/benefit-2.jpg" alt="Woman touching her face">
        <h3>Support clearer, calmer skin</h3>
        <p>Smart food swaps to reduce skin sensitivity.</p>
      </article>
      <article class="nlp-benefit">
        <img src="/images/nutrable-program/benefit-3.jpg" alt="Man rubbing his temples">
        <h3>Reduce headaches &amp; migraines</h3>
        <p>Identify foods that contribute to headaches</p>
      </article>
      <article class="nlp-benefit">
        <img src="/images/nutrable-program/benefit-4.jpg" alt="Woman concentrating at a laptop">
        <h3>Clear the brain fog</h3>
        <p>Make food choices that support focus</p>
      </article>
      <article class="nlp-benefit">
        <img src="/images/nutrable-program/benefit-5.jpg" alt="Man sleeping peacefully">
        <h3>Support better sleep</h3>
        <p>Learn how food triggers affect your sleep.</p>
      </article>
      <article class="nlp-benefit">
        <img src="/images/nutrable-program/benefit-6.jpg" alt="Man celebrating outdoors at sunrise">
        <h3>Improve energy</h3>
        <p>Build an eating plan that supports better energy.</p>
      </article>
    </div>
    <div class="nlp-btn-row">
      <button
        type="button"
        class="nlp-btn nlp-btn--navy"
        :disabled="actionDisabled"
        :aria-busy="actionLoading"
        @click="handleCtaClick"
      >
        <span>
          <span class="nlp-btn__label">{{ ctaLabel }}</span>
          <span v-if="!isProgramActive && !needsRegistration" class="nlp-btn__price">{{ programPrice }} <small>one-time payment</small></span>
        </span>
        <span class="nlp-btn__arrow" aria-hidden="true">&rarr;</span>
      </button>
    </div>
  </div>
</section>

<section class="nlp-section nlp-section--grey">
  <div class="nlp-wrap">
    <div class="nlp-section__head">
      <h2 class="nlp-is-navy">A 12-Week Plan</h2>
      <p class="nlp-is-navy">to understand your food triggers and transform your diet.</p>
    </div>
    <div class="nlp-plan">

      <div class="nlp-stage">
        <div class="nlp-stage__week">WEEK 1</div>
        <div class="nlp-stage__marker" aria-hidden="true"></div>
        <div class="nlp-stage__card">
          <div class="nlp-stage__head">
            <span class="nlp-stage__badge"><img src="/images/nutrable-program/step-icon-1.png" alt=""></span>
            <span class="nlp-stage__title">Understand<br>Your Results</span>
          </div>
          <div class="nlp-stage__split">
            <div class="nlp-stage__col nlp-stage__col--you">
              <h4>You</h4>
              <img src="/images/nutrable-program/step-1a.jpg" alt="Viewing food intolerance results in the app">
              <p>Identify food triggers.</p>
            </div>
            <div class="nlp-stage__col nlp-stage__col--coach">
              <h4>Your Coach</h4>
              <img src="/images/nutrable-program/step-1b.jpg" alt="Coach writing a nutrition plan">
              <p>Create your plan &amp;&nbsp;food swaps.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="nlp-stage">
        <div class="nlp-stage__week">WEEK 4</div>
        <div class="nlp-stage__marker" aria-hidden="true"></div>
        <div class="nlp-stage__card">
          <div class="nlp-stage__head">
            <span class="nlp-stage__badge"><img src="/images/nutrable-program/step-icon-2.png" alt=""></span>
            <span class="nlp-stage__title">Eliminate<br>&amp; Replace</span>
          </div>
          <div class="nlp-stage__split">
            <div class="nlp-stage__col nlp-stage__col--you">
              <h4>You</h4>
              <img src="/images/nutrable-program/step-2a.jpg" alt="Preparing fresh vegetables at home">
              <p>Cut trigger foods, &amp; try food swaps.</p>
            </div>
            <div class="nlp-stage__col nlp-stage__col--coach">
              <h4>Your Coach</h4>
              <img src="/images/nutrable-program/step-2b.jpg" alt="Coach checking in by phone">
              <p>Check in &amp; track your progress.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="nlp-stage">
        <div class="nlp-stage__week">WEEK 8</div>
        <div class="nlp-stage__marker" aria-hidden="true"></div>
        <div class="nlp-stage__card">
          <div class="nlp-stage__head">
            <span class="nlp-stage__badge"><img src="/images/nutrable-program/step-icon-3.png" alt=""></span>
            <span class="nlp-stage__title">Reintroduce<br>&amp; Learn</span>
          </div>
          <div class="nlp-stage__split">
            <div class="nlp-stage__col nlp-stage__col--you">
              <h4>You</h4>
              <img src="/images/nutrable-program/step-3a.jpg" alt="Chopping vegetables in the kitchen">
              <p>Reintroduce foods slowly.</p>
            </div>
            <div class="nlp-stage__col nlp-stage__col--coach">
              <h4>Your Coach</h4>
              <img src="/images/nutrable-program/step-3b.jpg" alt="Coach on a video call">
              <p>Review progress &amp; adjust your plan.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="nlp-stage">
        <div class="nlp-stage__week">WEEK 12</div>
        <div class="nlp-stage__marker" aria-hidden="true"></div>
        <div class="nlp-stage__card">
          <div class="nlp-stage__head">
            <span class="nlp-stage__badge"><img src="/images/nutrable-program/step-icon-4.png" alt=""></span>
            <span class="nlp-stage__title">Eat with<br>Confidence</span>
          </div>
          <div class="nlp-stage__split">
            <div class="nlp-stage__col nlp-stage__col--you">
              <h4>You</h4>
              <img src="/images/nutrable-program/step-4a.jpg" alt="Enjoying a balanced meal">
              <p>Eat confidently with new habits.</p>
            </div>
            <div class="nlp-stage__col nlp-stage__col--coach">
              <h4>Your Coach</h4>
              <img src="/images/nutrable-program/step-4b.jpg" alt="Coach reviewing a long term plan">
              <p>Plan for long-term success.</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<section class="nlp-section">
  <div class="nlp-wrap">
    <div class="nlp-section__head">
      <h2 class="nlp-is-navy">What&rsquo;s Included</h2>
      <p>Expert guidance and personalised nutrition support wherever you go.</p>
    </div>
    <div class="nlp-included">
      <div class="nlp-included__preview">
        <img src="/images/nutrable-program/phone.jpg" alt="The Nutrable app showing a personalised plan and today's actions">
      </div>
      <div class="nlp-included__list">
        <div class="nlp-included__item">
          <span class="nlp-included__icon"><img src="/images/nutrable-program/inc-icon-1.png" width="50" height="46" alt=""></span>
          <span>Your dedicated nutrition coach</span>
        </div>
        <div class="nlp-included__item">
          <span class="nlp-included__icon"><img src="/images/nutrable-program/inc-icon-2.png" width="40" height="33" alt=""></span>
          <span>Personalised nutrition plan</span>
        </div>
        <div class="nlp-included__item">
          <span class="nlp-included__icon"><img src="/images/nutrable-program/inc-icon-3.png" width="38" height="36" alt=""></span>
          <span>Meal and recipe guidance</span>
        </div>
        <div class="nlp-included__item">
          <span class="nlp-included__icon"><img src="/images/nutrable-program/inc-icon-4.png" width="47" height="48" alt=""></span>
          <span>Elimination &amp; reintroduction support</span>
        </div>
        <div class="nlp-included__item">
          <span class="nlp-included__icon"><img src="/images/nutrable-program/inc-icon-5.png" width="44" height="50" alt=""></span>
          <span>Regular coach check-ins and messaging</span>
        </div>
        <div class="nlp-included__item">
          <span class="nlp-included__icon"><img src="/images/nutrable-program/inc-icon-6.png" width="45" height="48" alt=""></span>
          <span>Progress reviews and plan adjustments</span>
        </div>
      </div>
    </div>
    <div class="nlp-btn-row">
      <button
        type="button"
        class="nlp-btn nlp-btn--navy"
        :disabled="actionDisabled"
        :aria-busy="actionLoading"
        @click="handleCtaClick"
      >
        <span>
          <span class="nlp-btn__label">{{ ctaLabel }}</span>
          <span v-if="!isProgramActive && !needsRegistration" class="nlp-btn__price">{{ programPrice }} <small>one-time payment</small></span>
        </span>
        <span class="nlp-btn__arrow" aria-hidden="true">&rarr;</span>
      </button>
    </div>
  </div>
</section>

<section class="nlp-section">
  <div class="nlp-wrap">
    <div class="nlp-section__head">
      <h2 class="nlp-is-navy">Meet Your Nutrition Coach</h2>
      <p>Loved by members, our team of expert nutrition coaches are here to guide, support and empower you.</p>
    </div>
    <div class="nlp-coaches">
      <article class="nlp-coach"><img src="/images/nutrable-program/coach-1.jpg" alt="Coach Mike"><h3>Coach Mike</h3><p>Head Nutritionist</p></article>
      <article class="nlp-coach"><img src="/images/nutrable-program/coach-2.jpg" alt="Coach Louise"><h3>Coach Louise</h3><p>Weight Loss</p></article>
      <article class="nlp-coach"><img src="/images/nutrable-program/coach-3.jpg" alt="Coach Julia"><h3>Coach Julia</h3><p>Sleep, Energy &amp; Mood</p></article>
      <article class="nlp-coach"><img src="/images/nutrable-program/coach-4.jpg" alt="Coach Brigitta"><h3>Coach Brigitta</h3><p>Menopause &amp; Hormones</p></article>
      <article class="nlp-coach"><img src="/images/nutrable-program/coach-5.jpg" alt="Coach Lisa"><h3>Coach Lisa</h3><p>Fitness &amp; Performance</p></article>
    </div>
    <div class="nlp-creds">
      <div class="nlp-creds__item"><img src="/images/nutrable-program/badge-1.png" alt=""><p><b>CNHC Accredited</b><span>100s of qualified coaches</span></p></div>
      <div class="nlp-creds__item"><img src="/images/nutrable-program/badge-2.png" alt=""><p><b>45+</b><span>specialist areas</span></p></div>
      <div class="nlp-creds__item"><img src="/images/nutrable-program/badge-3.png" alt=""><p><b>10+ years</b><span>clinical experience</span></p></div>
    </div>
  </div>
</section>

<section class="nlp-section">
  <div class="nlp-wrap">
    <div class="nlp-section__head">
      <h2 class="nlp-is-purple">Real People. Real Results.</h2>
      <p>Don&rsquo;t just take our word for it, our member reviews speak for themselves.</p>
    </div>
    <div class="nlp-reviews">
      <article class="nlp-review">
        <div class="nlp-review__stars" aria-label="Rated 5 out of 5">
          <svg aria-hidden="true" focusable="false"><use href="#nlp-star"/></svg>
          <svg aria-hidden="true" focusable="false"><use href="#nlp-star"/></svg>
          <svg aria-hidden="true" focusable="false"><use href="#nlp-star"/></svg>
          <svg aria-hidden="true" focusable="false"><use href="#nlp-star"/></svg>
          <svg aria-hidden="true" focusable="false"><use href="#nlp-star"/></svg>
        </div>
        <blockquote>&ldquo;I had my results, but I wasn&rsquo;t sure what to actually do with them. My coach helped me understand which foods to focus on and find alternatives without feeling like I had to cut everything out.&rdquo;</blockquote>
        <cite>John, 42</cite>
      </article>
      <article class="nlp-review">
        <div class="nlp-review__stars" aria-label="Rated 5 out of 5">
          <svg aria-hidden="true" focusable="false"><use href="#nlp-star"/></svg>
          <svg aria-hidden="true" focusable="false"><use href="#nlp-star"/></svg>
          <svg aria-hidden="true" focusable="false"><use href="#nlp-star"/></svg>
          <svg aria-hidden="true" focusable="false"><use href="#nlp-star"/></svg>
          <svg aria-hidden="true" focusable="false"><use href="#nlp-star"/></svg>
        </div>
        <blockquote>&ldquo;The reintroduction stage was the part I was most nervous about, but having my coach there made such a difference. I now understand my triggers better and feel much more confident about what I can eat.&rdquo;</blockquote>
        <cite>Kathrin, 58</cite>
      </article>
    </div>
    <div class="nlp-figures">
      <div class="nlp-figures__item"><b>92%</b><span>Improve eating habits</span></div>
      <div class="nlp-figures__item"><b>85%</b><span>Stay on track managing their triggers</span></div>
      <div class="nlp-figures__item"><b>89%</b><span>Feel more in control and confident</span></div>
    </div>
    <div class="nlp-btn-row">
      <button
        type="button"
        class="nlp-btn nlp-btn--navy"
        :disabled="actionDisabled"
        :aria-busy="actionLoading"
        @click="handleCtaClick"
      >
        <span>
          <span class="nlp-btn__label">{{ ctaLabel }}</span>
          <span v-if="!isProgramActive && !needsRegistration" class="nlp-btn__price">{{ programPrice }} <small>one-time payment</small></span>
        </span>
        <span class="nlp-btn__arrow" aria-hidden="true">&rarr;</span>
      </button>
    </div>
  </div>
</section>

<section class="nlp-closing">
  <div class="nlp-closing__card">
    <div class="nlp-closing__copy">
      <h2>Ready to start?</h2>
      <p class="nlp-closing__lede">Get expert nutrition support throughout your 12-week food intolerance journey.</p>
      <p class="nlp-closing__price">{{ programPrice }}</p>
      <p class="nlp-closing__terms">ONE-TIME PAYMENT</p>
      <ul>
        <li><svg aria-hidden="true" focusable="false"><use href="#nlp-tick"/></svg>12-week structured food intolerance program</li>
        <li><svg aria-hidden="true" focusable="false"><use href="#nlp-tick"/></svg>1:1 expert nutrition support</li>
        <li><svg aria-hidden="true" focusable="false"><use href="#nlp-tick"/></svg>Personalised guidance for your journey</li>
        <li><svg aria-hidden="true" focusable="false"><use href="#nlp-tick"/></svg>No subscription or hidden fees</li>
      </ul>
      <button
        type="button"
        class="nlp-btn nlp-btn--pink"
        :disabled="actionDisabled"
        :aria-busy="actionLoading"
        @click="handleCtaClick"
      >
        <span class="nlp-btn__label">{{ ctaLabel }}</span>
        <span class="nlp-btn__arrow" aria-hidden="true">&rarr;</span>
      </button>
      <div class="nlp-closing__foot">
        <span class="nlp-closing__secure">
          <svg viewBox="0 0 23 26" aria-hidden="true" focusable="false">
            <path d="M11.5 1.2 21 4.6v8.2c0 5.4-3.9 9.9-9.5 11.9C5.9 22.7 2 18.2 2 12.8V4.6l9.5-3.4Z" fill="none" stroke="#3d3181" stroke-width="1.8" stroke-linejoin="round"/>
            <path d="m7.4 12.8 3 3 5.5-5.8" fill="none" stroke="#3d3181" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Secure &amp; private
        </span>
        <a class="nlp-powered" href="https://www.nutrable.com" target="_blank" rel="noopener">
          <span>powered by</span>
          <img src="/images/nutrable-program/logo-nutrable.png" width="107" height="19" alt="Nutrable">
        </a>
      </div>
    </div>
    <div class="nlp-closing__media">
      <img src="/images/nutrable-program/hero-cta.jpg" alt="Woman enjoying a fresh salad in a bright kitchen">
    </div>
  </div>
</section>

</main>
<UcariFooter />
</div>
</template>

<script>
import axios from 'axios';
import UserHeader from './UserHeader.vue';
import UcariFooter from './UcariFooter.vue';
import { logActivity } from '@/utils/activity';

export default {
  name: 'NutrableProgram',
  components: {
    UserHeader,
    UcariFooter,
  },
  data() {
    return {
      checkoutLoading: false,
      registrationLoading: false,
      registrationAttempted: false,
      showRegistrationConfirm: false,
      registrationResult: null,
      enrollmentLoaded: false,
      enrollmentLookupFailed: false,
      enrollment: null,
      error: '',
    };
  },
  created() {
    document.title = '12-Week Nutrition Coaching | UCARI';
  },
  mounted() {
    this.logActivity(51);
    this.fetchEnrollment();
  },
  computed: {
    programPrice() {
      return '$99.00';
    },
    actionLoading() {
      return this.checkoutLoading || this.registrationLoading;
    },
    actionDisabled() {
      return this.actionLoading || this.registrationInProgress || this.registrationNeedsReview;
    },
    isProgramActive() {
      if (!this.enrollment || this.enrollment.status !== 'active') return false;
      const endDate = this.enrollment.program_end_at || this.enrollment.programEndAtUtc;
      return !endDate || new Date(endDate).getTime() > Date.now();
    },
    needsRegistration() {
      return this.enrollment?.payment_status === 'paid'
        && this.enrollment?.status === 'registration_pending'
        && ['not_requested', 'failed'].includes(
          this.enrollment?.registration_status || 'not_requested'
        );
    },
    registrationNeedsReview() {
      return this.enrollment?.registration_status === 'manual_review';
    },
    registrationInProgress() {
      return this.enrollment?.registration_status === 'registering';
    },
    programAccessUrl() {
      return this.enrollment?.access_url
        || this.enrollment?.appUrl
        || this.enrollment?.nutrableAccessUrl
        || 'https://nutrable.com/my-plan';
    },
    ctaLabel() {
      if (this.isProgramActive) return 'Access Nutrable Account';
      if (this.needsRegistration) {
        return this.registrationLoading ? 'Activating…' : 'Activate Nutrable Access';
      }
      if (this.registrationInProgress) return 'Activation in progress';
      if (this.registrationNeedsReview) return 'Registration needs review';
      return this.checkoutLoading ? 'Opening Checkout...' : 'Start Your Program';
    },
    showProgramNotice() {
      return this.isProgramActive
        || this.needsRegistration
        || this.registrationInProgress
        || this.registrationNeedsReview
        || ['success', 'cancelled'].includes(this.$route.query.status);
    },
    programNoticeTitle() {
      if (this.registrationResult?.isNewUser) return 'Check your email to set up Nutrable';
      if (this.needsRegistration) return 'Payment confirmed — activate your program';
      if (this.registrationInProgress) return 'Your Nutrable access is being activated';
      if (this.registrationNeedsReview) return 'We need to confirm your Nutrable access';
      if (this.isProgramActive) return 'Your 12-week Nutrable program is active';
      if (this.$route.query.status === 'success') {
        if (!this.enrollmentLoaded) return 'Confirming your payment';
        if (this.enrollmentLookupFailed) return 'We could not confirm your payment';
        return 'Payment is processing';
      }
      return 'Checkout cancelled';
    },
    programNoticeBody() {
      if (this.registrationResult?.isNewUser) {
        const ucariConfirmation = this.registrationResult.confirmationEmailSent
          ? ' UCARI also sent you a confirmation email.'
          : '';
        return `Your 12-week access is active. Look for account setup instructions from no-reply@nutrable.com at ${this.enrollment?.registration_email}.${ucariConfirmation}`;
      }
      if (this.needsRegistration) {
        return `Confirm that you want to register ${this.enrollment?.registration_email} with Nutrable. Your 12-week access begins when you activate it.`;
      }
      if (this.registrationInProgress) {
        return 'Please wait while we confirm your Nutrable membership. Do not submit another purchase.';
      }
      if (this.registrationNeedsReview) {
        return 'Please contact UCARI support before trying again so we do not accidentally extend your membership twice.';
      }
      if (this.isProgramActive) {
        const endDate = this.enrollment?.program_end_at || this.enrollment?.programEndAtUtc;
        return endDate
          ? `Your current program runs through ${this.formatDate(endDate)}.`
          : 'Your nutrition program is ready whenever you are.';
      }
      if (this.$route.query.status === 'success') {
        if (this.enrollmentLookupFailed) {
          return 'Please refresh this page. If the problem continues, contact UCARI support before trying to pay again.';
        }
        return 'We are waiting for final payment confirmation. This page will show your program access as soon as it is ready.';
      }
      return 'No payment was made. You can start the program whenever you are ready.';
    },
  },
  methods: {
    logActivity,
    getAuthConfig() {
      const accessToken = localStorage.getItem('accessToken');
      const cid = localStorage.getItem('cid');

      return {
        withCredentials: true,
        headers: {
          ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
          ...(cid ? { cid } : {}),
        },
      };
    },
    async fetchEnrollment() {
      this.enrollmentLookupFailed = false;
      try {
        const checkoutSessionId = String(this.$route.query.session_id || '').trim();
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/nutrable/enrollment`,
          {
            ...this.getAuthConfig(),
            params: checkoutSessionId ? { session_id: checkoutSessionId } : {},
          }
        );
        this.enrollment = data?.enrollment || data || null;
        if (this.$route.query.status === 'success'
          && this.needsRegistration
          && !this.registrationAttempted) {
          this.registrationAttempted = true;
          await this.confirmRegistration();
        }
      } catch (e) {
        this.enrollmentLookupFailed = true;
        if (e.response?.status !== 404) {
          console.error('Failed to load Nutrable enrollment:', e);
        }
      } finally {
        this.enrollmentLoaded = true;
      }
    },
    handleCtaClick() {
      if (this.isProgramActive) {
        this.openProgram();
        return;
      }
      if (this.registrationInProgress || this.registrationNeedsReview) return;
      if (this.needsRegistration) {
        this.openRegistrationConfirm();
        return;
      }
      this.startProgram();
    },
    noticeAction() {
      if (this.needsRegistration) {
        this.openRegistrationConfirm();
        return;
      }
      this.openProgram();
    },
    async openRegistrationConfirm() {
      this.error = '';
      this.showRegistrationConfirm = true;
      await this.$nextTick();
      this.$refs.registrationDialog?.focus();
    },
    closeRegistrationConfirm() {
      if (!this.registrationLoading) this.showRegistrationConfirm = false;
    },
    async confirmRegistration() {
      if (this.registrationLoading) return;
      this.registrationLoading = true;
      this.error = '';
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API_URL}/api/nutrable/register`,
          { confirmed: true },
          this.getAuthConfig()
        );
        this.enrollment = data?.enrollment || this.enrollment;
        this.registrationResult = data || null;
        this.showRegistrationConfirm = false;
      } catch (e) {
        this.showRegistrationConfirm = false;
        await this.showCheckoutError(
          e.response?.data?.error
            || 'We could not activate Nutrable access. Please contact UCARI support.'
        );
        await this.fetchEnrollment();
      } finally {
        this.registrationLoading = false;
      }
    },
    async startProgram() {
      if (this.checkoutLoading) return;
      this.error = '';
      this.checkoutLoading = true;
      this.logActivity(52);
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API_URL}/api/stripe/nutrable/checkout`,
          {},
          this.getAuthConfig()
        );
        if (data?.url) {
          window.location.assign(data.url);
        } else if (data?.requiresRegistration && data?.enrollment) {
          this.enrollment = data.enrollment;
          await this.openRegistrationConfirm();
        } else {
          await this.showCheckoutError('We could not open checkout. Please try again.');
        }
      } catch (e) {
        await this.showCheckoutError(
          e.response?.data?.error
            || 'Nutrable checkout is not available yet. Please try again later.'
        );
      } finally {
        this.checkoutLoading = false;
      }
    },
    async showCheckoutError(message) {
      this.error = message;
      await this.$nextTick();
      this.$refs.checkoutError?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.$refs.checkoutError?.focus({ preventScroll: true });
    },
    openProgram() {
      this.logActivity(53);
      window.location.assign(this.programAccessUrl);
    },
    formatDate(value) {
      return new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      }).format(new Date(value));
    },
  },
};
</script>
